export const OBJECTION_STATUS_LABELS = {
  draft: "مسودة",
  generated: "تم التجهيز",
  sending: "جارٍ الإرسال",
  sent: "تم الإرسال",
  failed: "فشل الإرسال",
};

export const EMAIL_STATUS_LABELS = {
  pending: "بانتظار الإرسال",
  sent: "تم الإرسال",
  failed: "فشل الإرسال",
};

export function objectionStatusLabel(status) {
  return OBJECTION_STATUS_LABELS[status] || "مسودة";
}

export function emailStatusLabel(status) {
  return EMAIL_STATUS_LABELS[status] || "بانتظار الإرسال";
}

export function objectionStatusVariant(status) {
  if (status === "sent") return "done";
  if (status === "failed") return "rejected";
  if (status === "sending") return "pending";
  return "manual";
}
